var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#f5f5f5"}},[_c('div',[_c('img',{attrs:{"src":_vm.agent_info.estimate_banner.url}})]),_c('reckon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }